import React, { Component } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
} from "reactstrap";
import { v4 } from "uuid";

const BREADCRUMP_DICT = {
  historic: {value: 'Histórico'},
  opportunity: {value: 'Oportunidades'},
  byOpportunity: {value: 'CPRFs por oportunidade'},
  newCpr: {value: 'Nova CPRF'},
  politicascomerciais: {value: 'Políticas comerciais'},
  byCpf: {value: 'Por CPF'},
  category: {value: 'Por Categoria'},
  promoCodes: {value: 'Códigos promocionais'},
  branches: {value: 'Filiais'},
  workSheets: {value: 'Planilhas'},
  client: {value: 'Clientes'},
  clientList: {value: 'Clientes'},
  communication: {value: 'Comunicação'},
  comunicacao: {value: 'Comunicação'},
  notification: {value: 'Notificações'},
  sentinels: {value: 'Sentinelas'},
  listaTickets: {value: 'Lista'},
  saldoConta: {value: 'Saldo em conta'},
  activation: {value: 'Ativação'},
  liquidateCupons: {value: 'Liquidação de cupons'},
  relatorioDiario: {value: 'Relatório de integração do financeiro'},
  searchCupons: {value: 'Buscar cupons'},
  reports: {value: 'Relatórios'},
  jurosPassivo: {value: 'Juros passivo'},
  documents: {value: 'Documentos'}
}

class BreadcrumbHistory extends Component {
  state = {
    date: "15 Jan 2020",
  };

  renderBreadCrumbs = () => {

    let data = this.props.url
    let route = data[data.length - 1]
    let result = route.pathname !== '/' ? route.pathname
      .split("/")
      .slice(1)
      .map((route) =>  {
        let replacedRoute = route.replace("-", "")
        return BREADCRUMP_DICT[replacedRoute] 
          ? BREADCRUMP_DICT[replacedRoute].value 
            .split("-")
            .map((word) => word[0] === '' ? '/' : word[0].toUpperCase() + word.slice(1))
            .join(" ")
          : route
            .split("-")
            .map((word) => word[0] === '' ? '/' : word[0]?.toUpperCase() + word.slice(1))
            .join(" ")
        }
      ) : [""];
    const length = result.length;
    return result.map((item, index) =>
      length === index + 1 ? (
        <BreadcrumbItem key={v4()} className={"active"}>
          {item.replace('Renovacao', 'Renovação')}
        </BreadcrumbItem>
      ) : (
        <BreadcrumbItem key={v4()}>{item.replace('Renovacao', 'Renovação')}</BreadcrumbItem>
      )
    );
  };

  render() {
    return (
      <>
        {this.props.url !== "/app/chat" ? (
          <Row noGutters>
            <Col lg={5}>
              <Breadcrumb tag="nav" listTag="div">
                {this.renderBreadCrumbs()}
              </Breadcrumb>
            </Col>
            
          </Row>
        ) : null}
      </>
    );
  }
}

export default BreadcrumbHistory;
